import { createAuthClient } from "better-auth/react";
import { adminClient, genericOAuthClient } from "better-auth/client/plugins";

/**
 * Better Auth client instance.
 * In dev, baseURL is empty so requests go through Vite's proxy (/api -> :8787).
 * In production, baseURL points to the Worker.
 */
const apiBase = import.meta.env.VITE_API_URL || "";

export const authClient = createAuthClient({
  baseURL: apiBase,
  basePath: "/api/auth",
  plugins: [adminClient(), genericOAuthClient()],
});

// Re-export hooks for convenience
export const { useSession, signIn, signOut, signUp } = authClient;
